import { Input, Select } from '@components/common';
import { useState } from 'react';
import styled from 'styled-components';
// import '../../../common/Select/Select.scss';

interface CardFormProps {
    cardMonth: string;
    cardYear: string;
    onUpdateState(state: string, value: any): void;
    cardNumberRef: any;
    cardHolderRef: any;
    cardDateRef: any;
    loading?: any;
}

const currentYear = new Date().getFullYear();
const monthsArr = Array.from({ length: 12 }, (x, i) => {
    const month = i + 1;
    return month <= 9 ? '0' + month : month;
});
const yearsArr = Array.from({ length: 9 }, (_x, i) => currentYear + i);

const CardForm = ({
    cardMonth,
    cardYear,
    onUpdateState,
    cardNumberRef,
    cardHolderRef,
    cardDateRef,
    loading,
}: CardFormProps) => {
    const [cardNumber, setCardNumber] = useState('');
    const handleFormChange = ({ name, value }: { name: string; value: any }) => {
        onUpdateState(name, value);
    };

    const onCardNumberChange = (name: string, value: string) => {
        let cardNumber = value;
        value = value.replace(/\D/g, '');
        if (/^3[47]\d{0,13}$/.test(value)) {
            cardNumber = value.replace(/(\d{4})/, '$1 ').replace(/(\d{4}) (\d{6})/, '$1 $2 ');
        } else if (/^3(?:0[0-5]|[68]\d)\d{0,11}$/.test(value)) {
            // diner's club, 14 digits
            cardNumber = value.replace(/(\d{4})/, '$1 ').replace(/(\d{4}) (\d{6})/, '$1 $2 ');
        } else if (/^\d{0,16}$/.test(value)) {
            // regular cc number, 16 digits
            cardNumber = value
                .replace(/(\d{4})/, '$1 ')
                .replace(/(\d{4}) (\d{4})/, '$1 $2 ')
                .replace(/(\d{4}) (\d{4}) (\d{4})/, '$1 $2 $3 ');
        }

        setCardNumber(cardNumber.trimRight());
        onUpdateState(name, cardNumber);
    };

    return (
        <Container>
            <InputGroup>
                <Input
                    label="Card Number"
                    value={cardNumber}
                    maxLength={19}
                    readOnly={loading}
                    name="cardNumber"
                    allowNumber={true}
                    onChange={({ name, value }: { name: string; value: string }) => {
                        onCardNumberChange(name, value);
                    }}
                />
            </InputGroup>
            <InputGroup>
                <Input
                    label="Name"
                    name="cardHolder"
                    readOnly={loading}
                    onChange={handleFormChange}
                />
            </InputGroup>

            <InputGroup>
                <div
                    className="userDetails-group card-form_grid--exp"
                    style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
                        gap: '10px',
                    }}>
                    <Select
                        label="MM"
                        maxLength={2}
                        onChange={(value: string) => {
                            onUpdateState('cardMonth', value);
                        }}
                        readOnly={loading}
                        allowNumber={true}
                        // customHeight={'130px'}
                        options={monthsArr.map(val => {
                            return {
                                label: val.toString(),
                            };
                        })}
                    />

                    <Select
                        label="YYYY"
                        maxLength={4}
                        readOnly={loading}
                        allowNumber={true}
                        onChange={(value: string) => {
                            onUpdateState('cardYear', value);
                        }}
                        // customHeight={'130px'}
                        options={yearsArr.map(val => {
                            return {
                                label: val.toString(),
                            };
                        })}
                    />
                </div>

                <InputGroup>
                    <Input
                        label="CVV"
                        name="cardCVV"
                        maxLength={4}
                        readOnly={loading}
                        allowNumber={true}
                        onFocus={() => onUpdateState('isCardFlipped', true)}
                        onBlur={() => onUpdateState('isCardFlipped', false)}
                        onChange={handleFormChange}
                    />
                </InputGroup>
            </InputGroup>
        </Container>
    );
};
const Container = styled.div`
    margin-top: 1rem;
`;

const InputGroup = styled.div`
    margin-top: 0.7rem;
`;
export default CardForm;
